__turbopack_context__.v({
  "dot": "Toggle-module-scss-module__O1VmdW__dot",
  "lock-icon": "Toggle-module-scss-module__O1VmdW__lock-icon",
  "switch": "Toggle-module-scss-module__O1VmdW__switch",
  "toggle": "Toggle-module-scss-module__O1VmdW__toggle",
  "toggle-label": "Toggle-module-scss-module__O1VmdW__toggle-label",
});
